import { AbstractControl, UntypedFormControl, ValidationErrors } from '@angular/forms';
import { StepType } from '../enum/step-type.enum';
import { CreditApplication } from '../interfaces/credit-application.interface';

export class CustomValidator {

  
  // Validates URL
  static DOBValidator(DOB: UntypedFormControl): any {
    if (DOB.pristine) {
      return null;
    }
    const dob2 = DOB.value.match(/\d/g);
    if (!dob2) {
      return null;
    }
    if (dob2.length < 8) {
      return null;
    } else {
      const month = Number(dob2.join('').substr(0, 2));
      const day = Number(dob2.join('').substr(2, 2));
      const year = Number(dob2.join('').substr(4, 4));
      const cYear = new Date().getFullYear();
      if ((day > 31 || day < 1) || (month > 12 || month < 1) || ((year > (cYear - 18)) || (year < (cYear - 100)))) {
        return {
          invalidDOB: true
        };
      } else {
        const date = new Date(year, month - 1, day);
        if (date.getFullYear() === year && date.getMonth() === month - 1) {
          return null;
        } else {
          return {
            invalidDOB: true
          };
        }
      }
    }
  }

  static SSNValidator(SSN: UntypedFormControl): any {
    if (SSN.pristine) {
      return null;
    }
    const ssn2 = SSN.value.match(/\d/g);
    if (!ssn2) {
      return true;
    }
    if (ssn2.length !== 9) {
      return null;
    } else {
      const set1 = new Set(ssn2);
      if (set1.size === 1) {
        return {
          inValidSSN: true
        };
      } else {
        return null;
      }
    }
  }

  static SSNDuplicationValidator(stepType: StepType, ca: CreditApplication, ssnFlag: number): any {

    const result = (SSN: UntypedFormControl): any => {
      if (SSN.pristine) {
        return null;
      }
      if (stepType === StepType.CoBuyer) {
        const buyerSSN = ca[StepType.Buyer].financialInformation.securityInformation.ssn;
        if (buyerSSN.length === 9) {
          if (SSN.value.length === ssnFlag && buyerSSN === SSN.value.replace(/-/g, '')) {
            return {
              cobuyerInvalid: true
            };
          } else {
            return null;
          }
        } else {
          // prepopulated from server then
          if (SSN.value.length === ssnFlag && buyerSSN === SSN.value.replace(/-/g, '').substr(5, 4)) {
            return {
              inValidSSN: true
            };
          } else {
            return null;
          }
        }
      } else {
        return null;
      }
    };
    return result;
  }

  static matchSSN(group): any {
    const ssn = group.controls.SSN;
    const confirm = group.controls.SSNConfim;
    if (confirm.pristine && ssn.pristine) {
       return null;
    }
    group.markAsTouched();
    if (ssn.value === confirm.value) {
       return null;
    }
    return {
       SSNMatchingError: true
    };
 }


  // static matchSSN(control: AbstractControl): ValidationErrors | null {
  //     if (control) {
  //       const ssn = control.get('SSN')?.value;
  //       const confirm = control.get('SSNConfim')?.value;
    
  //     if (ssn && confirm && confirm.pristine && ssn.pristine) {
  //       control.get('SSN')?.setErrors({required_if: true});
  //       return ({required_if: true});
  //     } else {
  //       control.get('SSN')?.setErrors(null);
  //     }
  //     if (!ssn && !confirm) {
  //       control.get('ssn')?.setErrors({required_at_least: true});
  //       control.get('confirm')?.setErrors({required_at_least: true});
       
  //       return ({required_at_least: true});
  //     } else {
  //       control.get('ssn')?.setErrors(null);
  //       control.get('confirm')?.setErrors(null);
       
  //     }
  //     if (ssn && confirm && ssn === confirm) {
  //       control.get('ssn')?.setErrors({SSNMatchingError: true});
  //       control.get('confirm')?.setErrors({SSNMatchingError: true});
  //       return ({SSNMatchingError: true});
  //     }
  //   }
  //   return null;
  // }


  static optionalValidationDOBSSN(group): any {
    const ssn = group.controls.SSN;
    const dob = group.controls.DOB;
    if (ssn.value === '' && dob.value === '') {
      return { invalidOptionalError: true };
    }
    return null;
  }

  static areaCodeValidator(areaCode: UntypedFormControl): any { 
    return (areaCode?.value?.length > 1 && areaCode?.value?.indexOf('(1') === 0) ? { invalidAreaCode: true } : null;
  }
}
